import React, { useState, useEffect } from "react";
import { Tabs, Modal, Spin, message, Card, Button, Tag, Typography, Row, Col, Space, } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useParams } from "react-router-dom";
import TabPane from "antd/lib/tabs/TabPane";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css"
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import SidebarLayoutConsumer from './SidebarLayoutConsumer';
import LoanDetailsHeaderForAdministrator from "./LoanDetailsHeaderForAdministrator";
import AssessmentTabForAdministrator from "./AssessmentTabForAdministrator";
import ApplicationDetailsTabForAdministrator from "./ApplicationDetailsTabForAdministrator";
import FinancialStatementTabForAdministrator from "./FinancialStatementTabForAdministrator";
import ConcludeLoanRequestForAdministrator from "./ConcludeLoanRequestForAdministrator";

import _consumerService from "../../../modules/consumerService";
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import '../../../assets/dist/ConsumerProject/Administrator/Administrator.css';


export default function LoanApplicationDetailsForAdministrator() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  let data = location.state;
  let applicationObjId = "";
  let applicationId = "";
  let applicationStatusId = null;
  let emailId = '';

  if (data && data.email) {
    emailId = data.email;
  }

  if (data && data.applicationData && data.applicationData.Id) {
    applicationObjId = data.applicationData.Id;
  }

  if (data && data.applicationData && data.applicationData.ApplicationId) {
    applicationId = data.applicationData.ApplicationId;
  }

  if (data && data.applicationData && data.applicationData.Application_Status_Id) {
    applicationStatusId = data.applicationData.Application_Status_Id;
  }

  const [applicantDetails, setApplicantDetails] = useState([]);
  const isCapitalProvider = JSON.parse(localStorage.getItem("IsCapitalProviderFlag"));

  const [activeKey, setActiveKey] = useState("1");
  const params = useParams();
  const ApplicationObjId = params.Id;
  const previewTabChange = (key) => {
    setActiveKey(key);
  }

  const goToMyApplications = () => {
    // history.push({ pathname: routes.administratorDashboard.path });

    if (isCapitalProvider) {
      history.push(routes.capitalProviderDashboard.path);
    } else {
      history.push(routes.administratorDashboard.path);
    }
  }

  useEffect(() => {
    getApplicantDetailsByID(ApplicationObjId);
  }, []);

  const getApplicantDetailsByID = async () => {
    setLoading(true);
    try {
      const res = await _consumerService.getConsumerInformationByConsumerId(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        localStorage.setItem("ConsumerUserId", res?.data?.Id);

        setApplicantDetails(resObj);
        setLoading(false);
      } else {
        message.error(COMMON_ERROR_MSG)
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };



  return (
    <Spin spinning={loading}>
      <SidebarLayoutConsumer>

        <Row justify="center" align="middle" className="backtoApplicationsROw"  >
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            className="applicationbuttons mb10"
          >
            <Space direction="vertical" size={4}>
              <Button
                className="backtoApplicationsButtonDefault"
                type="text"
                icon={<LeftOutlined />}
                onClick={goToMyApplications}
              >
                Back to Applications
              </Button>
            </Space>
          </Col>
        </Row>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className="consumerDetailApplicationOverViewColumn"
        >
          <LoanDetailsHeaderForAdministrator applicantDetails={applicantDetails} />

        </Col>




        {/* <Row gutter={30}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}>
            <Tabs
              className="previewTab"
              activeKey={activeKey}
              onChange={previewTabChange}
              // tabBarExtraContent={
              //   isCapitalProvider && (
              //     <div style={{ paddingRight: 16 }}>
              //       <strong>Banker Name:</strong>{" "}
              //       {applicantDetails?.sponserModel?.BankerName}
              //     </div>
              //   )
              // }
            >
              <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="1">
                <div>
                  <AssessmentTabForAdministrator activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setApplicationDetailsTab">Application Details</span>} key="2">
                <div>
                  <ApplicationDetailsTabForAdministrator activeKey={activeKey} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="3">
                <div>
                  <FinancialStatementTabForAdministrator activeKey={activeKey} applicantDetails={applicantDetails} />
                </div>
              </TabPane>
              <TabPane tab={<span id="setConcludeLoanRequestTab">{isCapitalProvider ? "Conclude Loan Request" : "Send to Capital Provider"}</span>} key="4">
                <div>
                  <ConcludeLoanRequestForAdministrator activeKey={activeKey} applicantDetails={applicantDetails} />
                </div>
              </TabPane>
            </Tabs>
          </Col>

        </Row> */}

        <Row gutter={30}>
          <Col xs={24} sm={24} md={24} lg={24} xl={18}>
            <div className="applicationDetailcontainer  mr5">

              {/* --- Tabs Section --- */}
              <Tabs
                className="custom-pill-tabs"
                activeKey={activeKey}
                onChange={previewTabChange}
              >
                <TabPane tab={<span id="setAssessmentTab">Assessment</span>} key="1" />
                <TabPane tab={<span id="setApplicationDetailsTab">Application Details</span>} key="2" />
                <TabPane tab={<span id="setFinancialStatementTab">Financial Statement</span>} key="3" />
                {/* <TabPane
                  tab={
                    <span id="setConcludeLoanRequestTab">
                      {isCapitalProvider ? "Conclude Loan Request" : "Send to Capital Provider"}
                    </span>
                  }
                  key="4"
                /> */}
              </Tabs>

              {/* --- Content Section --- */}
              <div>
                {activeKey === "1" && (
                  <AssessmentTabForAdministrator activeKey={activeKey} />
                )}

                {activeKey === "2" && (
                  <ApplicationDetailsTabForAdministrator activeKey={activeKey} />
                )}

                {activeKey === "3" && (
                  <FinancialStatementTabForAdministrator
                    activeKey={activeKey}
                    applicantDetails={applicantDetails}
                  />
                )}

                {/* {activeKey === "4" && (
          <ConcludeLoanRequestForAdministrator
            activeKey={activeKey}
            applicantDetails={applicantDetails}
          />
        )} */}
              </div>

            </div>
          </Col>
        </Row>

        <Row gutter={30}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={18}
            className="consumerDetailApplicationOverViewColumn ConcludeLoanRequestForAdministratorColumn"
          >
            <ConcludeLoanRequestForAdministrator
              activeKey={activeKey}
              applicantDetails={applicantDetails}
            />

          </Col>
        </Row>





      </SidebarLayoutConsumer>
    </Spin>
  );
}